import React, { RefObject } from "react";
import { PrimaryButton, SecondaryButton } from "src/ui/shared/CustomButton";

import { LoadingButtonProps } from "@mui/lab";
import { TooltipProps } from "@mui/material";

export interface DropdownTriggerProps extends LoadingButtonProps {
    onClick: () => void;
    anchorRef: RefObject<HTMLButtonElement | null>;
    tooltipProps?: Omit<TooltipProps, "arrow" | "children">;
    buttonType?: "primary" | "secondary";
}

export function DropdownTrigger({
    children,
    onClick,
    anchorRef,
    className = "",
    buttonType = "secondary",
    ...props
}: DropdownTriggerProps): React.JSX.Element {
    const handleToggle = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        onClick();
    };

    const ButtonComponent = buttonType === "primary" ? PrimaryButton : SecondaryButton;

    return (
        <ButtonComponent
            ref={anchorRef}
            aria-haspopup="true"
            onClick={(e) => handleToggle(e)}
            className={`${className}`}
            {...props}
        >
            {children}
        </ButtonComponent>
    );
}
